/* eslint-disable */
import React from "react";
// @material-ui/core components
import {
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  InputAdornment,
} from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import ls from "local-storage";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import Button from "components/CustomButtons/Button.js";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import PhotoCamera from "@material-ui/icons/PhotoCamera";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import styles from "assets/jss/material-dashboard-react/views/EventStyle.js";
import { db, storage } from "../Firebase/firebase.js";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(styles);
const tablestyle = {
  backgroundColor: "#171942",
  color: "white",
};

export default function Prize() {
  let history = useHistory();
  const theme = useTheme();
  var mobileratio = useMediaQuery(theme.breakpoints.down("sm"));
  var desktop = useMediaQuery(theme.breakpoints.between("2490", "4000"));
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [image, setImage] = React.useState("");
  const [viewimage, setviewImage] = React.useState("");
  const [prize_type, setType] = React.useState("");
  const imageRef = React.useRef(null);
  const viewimageRef = React.useRef(null);
  const nameRef = React.useRef("");
  const valueRef = React.useRef("");
  const descriptionRef = React.useRef("");
  const [rows, setRow] = React.useState([]);

  const updatenameRef = React.useRef("");
  const updatevalueRef = React.useRef("");
  const updatedescriptionRef = React.useRef("");
  const [viewname, setviewname] = React.useState("");
  const [viewvalue, setviewvalue] = React.useState("");
  const [docid, setDocid] = React.useState("");
  const [viewdescription, setviewdescription] = React.useState("");
  const [updateimgurl, setupdateimageurl] = React.useState("");
  const [viewflag, setviewflag] = React.useState(false);
  const [opendeletebox, setopendeletebox] = React.useState(false);
  const searchref = React.useRef("");
  const [searchflag, setsearchflag] = React.useState(true);
  const [img, clearimg] = React.useState(true);

  const openconfirmationbox = () => {
    setopendeletebox(true);
  };
  const closeconfirmationbox = () => {
    setopendeletebox(false);
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  function useDisplayImage() {
    const [result, setResult] = React.useState("");

    function uploader(e) {
      const imageFile = e.target.files[0];

      const reader = new FileReader();
      reader.addEventListener("load", (e) => {
        setResult(e.target.result);
      });

      reader.readAsDataURL(imageFile);
    }

    return { result, uploader };
  }

  const { result, uploader } = useDisplayImage();

  const handleImageChange = (event) => {
    clearimg(false);
    setImage(event.target.files[0]);
    uploader(event);
  };

  function useDisplayImageforView() {
    const [result2, setResult2] = React.useState();

    function uploader2(e) {
      const imageFile = e.target.files[0];

      const reader = new FileReader();
      reader.addEventListener("load", (e) => {
        setResult2(e.target.result);
        setupdateimageurl(e.target.result);
      });

      reader.readAsDataURL(imageFile);
    }

    return { result2, uploader2 };
  }

  const { result2, uploader2 } = useDisplayImageforView();

  const handleViewImageChange = (event) => {
    setviewImage(event.target.files[0]);

    uploader2(event);
  };
  const handleTypeChange = (event) => {
    setType(event.target.value);
  };
  const [open, setOpen] = React.useState(false);
  const [openViewDialog, setViewDialog] = React.useState(false);

  const handleClickOpen = () => {
    clearimg(true);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleViewClickOpen = () => {
    setViewDialog(true);
  };
  const handleViewArrowClose = () => {
    setViewDialog(false);
  };

  React.useEffect(() => {
    if (ls.get("currentuser") === "") {
      history.push("/login");
    } else {
      getPrizes();
    }
  }, []);

  var getPrizes = () => {
    let newArray = [];
    db.collection("prizes")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
        });
        setRow(newArray);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };

  const searchPrize = () => {
    if (searchflag === true) {
      let newArray = [];
      db.collection("prizes")
        .where("name", "==", searchref.current.value)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            newArray.push(doc.data());
          });
          setRow(newArray);
          setsearchflag(false);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    } else {
      searchref.current.value = "";
      getPrizes();
      setsearchflag(true);
    }
  };

  const viewPrize = (row) => {
    setviewflag(true);
    setviewname(row.name);
    setviewvalue(row.value);
    setviewdescription(row.description);
    setType(row.type);
    setviewImage(row.image);
    setupdateimageurl(row.image);
    setViewDialog(true);
  };

  const updatePrizeDialog = (row) => {
    setviewflag(false);
    setviewname(row.name);
    setviewvalue(row.value);
    setviewdescription(row.description);
    setType(row.type);
    setDocid(row.docId);
    setviewImage(row.image);
    setupdateimageurl(row.image);
    setViewDialog(true);
  };

  const handleViewClose = () => {
    if (setviewflag === true) {
      setViewDialog(false);
    } else {
      updatePrize();
    }
  };

  const deleteDialog = (row) => {
    setDocid(row.docId);
    setopendeletebox(true);
  };

  const DeletePrize = () => {
    db.collection("prizes")
      .doc(docid)
      .delete()
      .then(() => {
        setopendeletebox(false);
        getPrizes();
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      });
  };

  const updatePrize = () => {
    if (typeof viewimage === "object") {
      const ref = storage.ref(`/prizes/${viewimage.name}`);
      const uploadTask = ref.put(viewimage);
      uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref("prizes")
            .child(viewimage.name)
            .getDownloadURL()
            .then((url) => {
              db.collection("prizes")
                .doc(docid)
                .set(
                  {
                    name: updatenameRef.current.value,
                    value: updatevalueRef.current.value,
                    description: updatedescriptionRef.current.value,
                    type: prize_type,
                    image: url,
                  },
                  { merge: true }
                )
                .then(() => {
                  setViewDialog(false);
                  setTimeout(() => {
                    getPrizes();
                  }, 2000);
                })
                .catch((err) => {
                  console.log(err);
                });
            });
        }
      );
    } else {
      db.collection("prizes")
        .doc(docid)
        .set(
          {
            name: updatenameRef.current.value,
            value: updatevalueRef.current.value,
            description: updatedescriptionRef.current.value,
            type: prize_type,
            image: viewimage,
          },
          { merge: true }
        )
        .then(() => {
          setViewDialog(false);
          setTimeout(() => {
            getPrizes();
          }, 2000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const addPrize = () => {
    const ref = storage.ref(`/prizes/${image.name}`);
    const uploadTask = ref.put(image);
    uploadTask.on(
      "state_changed",
      (snapshot) => {},
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("prizes")
          .child(image.name)
          .getDownloadURL()
          .then((url) => {
            db.collection("prizes")
              .add({
                name: nameRef.current.value,
                value: valueRef.current.value,
                description: descriptionRef.current.value,
                type: prize_type,
                image: url,
              })
              .then((doc) => {
                db.collection("prizes").doc(doc.id).set(
                  {
                    docId: doc.id,
                  },
                  { merge: true }
                );
                setOpen(false);
                setTimeout(() => {
                  getPrizes();
                }, 2000);
              })
              .catch((err) => {
                console.log(err);
              });
          });
      }
    );
  };
  const classes = useStyles();
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  return (
    <>
      <GridContainer justify="flex-end">
        <GridItem xs={12} sm={6} md={4}>
          <div style={{ marginLeft: desktop ? "495px" : "80px" }}>
            <TextField
              placeholder="Search"
              variant="outlined"
              inputRef={searchref}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton onClick={searchPrize}>
                      {searchflag ? <SearchIcon /> : <ClearIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </GridItem>
      </GridContainer>
      <br></br>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer
            component={Paper}
            style={{
              height: 450,
              overflow: "scroll",
              overflowX: "auto",
              display: "inline-block",
            }}
          >
            <Table
              stickyHeader
              style={{ width: "100%" }}
              className={classes.table}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <TableCell style={tablestyle}>ID</TableCell>
                  <TableCell style={tablestyle} align="left">
                    Prize Name
                  </TableCell>
                  <TableCell style={tablestyle} align="left">
                    Type
                  </TableCell>
                  <TableCell style={tablestyle} align="left">
                    Value
                  </TableCell>
                  <TableCell style={tablestyle} align="left">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <StyledTableRow key={row.docId}>
                    <TableCell
                      onClick={() => viewPrize(row)}
                      style={{ color: "skyblue" }}
                      component="th"
                      scope="row"
                    >
                      {row.docId}
                    </TableCell>

                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left">{row.type}</TableCell>
                    <TableCell align="left">{row.value}</TableCell>
                    <TableCell align="left">
                      <div>
                        <IconButton onClick={() => deleteDialog(row)}>
                          <DeleteForeverIcon
                            style={{ color: "red", width: "18" }}
                          />
                        </IconButton>
                        <IconButton onClick={() => updatePrizeDialog(row)}>
                          <EditIcon style={{ color: "green", width: "18" }} />
                        </IconButton>
                      </div>
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <GridContainer justify="flex-end">
        <GridItem>
          <br></br>
          <Button
            onClick={handleClickOpen}
            style={{ backgroundColor: "#171942" }}
          >
            Add Prize
          </Button>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="Prize-title"
            aria-describedby="Prize-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="prize-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
                <h5 style={{ display: "inline-block" }}>Add Prize</h5>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 800, width: 600 }}>
              <div className="prize-form">
                <div
                  className="imageContainer"
                  style={{
                    width: "38%",
                    height: "150px",
                    backgroundColor: "transparent",
                    marginLeft: mobileratio ? 0 : "auto",
                    marginRight: "auto",
                    marginBottom: "auto",
                    marginTop: "auto",
                  }}
                >
                  <img
                    src={img ? "" : result}
                    ref={imageRef}
                    alt=""
                    style={{
                      height: "100%",
                      width: "100%",
                      backgroundSize: "cover",
                    }}
                  ></img>
                </div>
                <br></br>
                <div>
                  <input
                    value=""
                    onChange={handleImageChange}
                    accept="image/*"
                    id="icon-button-file"
                    type="file"
                    style={{ display: "none" }}
                  />
                  <label
                    style={{
                      marginLeft: mobileratio ? 0 : 200,
                      marginTop: -20,
                    }}
                    htmlFor="icon-button-file"
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      startIcon={<PhotoCamera />}
                    >
                      Upload
                    </Button>
                  </label>
                  <br></br>
                  <TextField
                    inputRef={nameRef}
                    required
                    label="Name"
                    variant="outlined"
                    style={{ marginRight: 12, width: 262 }}
                  />
                  {mobileratio ? (
                    <div>
                      <br></br>
                    </div>
                  ) : null}
                  <TextField
                    inputRef={valueRef}
                    required
                    label="Value"
                    variant="outlined"
                    style={{ width: 262 }}
                  />
                </div>
                <div>
                  {mobileratio ? <br></br> : <br></br>}
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    style={{ width: mobileratio ? 262 : 535 }}
                    required
                  >
                    <InputLabel id="type_label">Prize Type</InputLabel>
                    <Select
                      labelId="type_id"
                      id="prize_type"
                      value={prize_type}
                      onChange={handleTypeChange}
                      label="Prize Type"
                    >
                      <MenuItem value={"Door"}>Door</MenuItem>
                      <MenuItem value={"Medium"}>Medium</MenuItem>
                      <MenuItem value={"Large"}>Large</MenuItem>
                      <MenuItem value={"AdultCashPrizes"}>Adult Cash Prizes</MenuItem>
                      <MenuItem value={"YouthCashPrizes"}>Youth Cash Prizes</MenuItem>

                    </Select>
                  </FormControl>
                  {mobileratio ? (
                    <div>
                      <br></br>
                    </div>
                  ) : null}
                </div>
                {mobileratio ? <br></br> : <br></br>}
                <TextField
                  inputRef={descriptionRef}
                  required
                  label="Description"
                  multiline
                  rowsMax={5}
                  variant="outlined"
                  style={{ width: mobileratio ? 262 : 535 }}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                style={{
                  marginRight: mobileratio ? 75 : 15,
                  width: mobileratio ? 267 : 555,
                  backgroundColor: "#171942",
                }}
                onClick={addPrize}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openViewDialog}
            onClose={handleViewArrowClose}
            aria-labelledby="Prize-title"
            aria-describedby="Prize-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="prize-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleViewArrowClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 800, width: 600 }}>
              <div className="prize-form">
                <div
                  className="imageContainer"
                  style={{
                    width: "38%",
                    height: "150px",
                    backgroundColor: "transparent",
                    marginLeft: mobileratio ? 0 : "auto",
                    marginRight: "auto",
                    marginBottom: "auto",
                    marginTop: "auto",
                  }}
                >
                  <img
                    src={updateimgurl}
                    ref={viewimageRef}
                    alt=""
                    style={{
                      height: "100%",
                      width: "100%",
                      backgroundSize: "cover",
                    }}
                  ></img>
                </div>
                <br></br>
                <div>
                  <input
                    value=""
                    onChange={handleViewImageChange}
                    accept="image/*"
                    id="icon-button-file"
                    type="file"
                    style={{ display: "none" }}
                  />
                  <label
                    style={{
                      marginLeft: mobileratio ? 0 : 200,
                      marginTop: -20,
                    }}
                    htmlFor="icon-button-file"
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      startIcon={<PhotoCamera />}
                      style={{ display: viewflag ? "none" : "inline-block" }}
                    >
                      Upload
                    </Button>
                  </label>
                  <br></br>
                  <TextField
                    inputRef={updatenameRef}
                    value={viewflag ? viewname : null}
                    defaultValue={viewflag ? null : viewname}
                    required
                    label="Name"
                    variant="outlined"
                    style={{ marginRight: 12, width: 262 }}
                  />
                  {mobileratio ? (
                    <div>
                      <br></br>
                    </div>
                  ) : null}
                  <TextField
                    inputRef={updatevalueRef}
                    value={viewflag ? viewvalue : null}
                    defaultValue={viewflag ? null : viewvalue}
                    required
                    label="Value"
                    variant="outlined"
                    style={{ width: 262 }}
                  />
                </div>
                <div>
                  {mobileratio ? <br></br> : <br></br>}
                  {viewflag ? (
                    <TextField
                      value={prize_type}
                      required
                      label="Prize Type"
                      variant="outlined"
                      style={{ width: mobileratio ? 262 : 535 }}
                    />
                  ) : (
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      style={{ width: mobileratio ? 262 : 535 }}
                      required
                    >
                      <InputLabel id="type_label">Prize Type</InputLabel>

                      <Select
                        labelId="type_id"
                        id="prize_type"
                        value={prize_type}
                        onChange={handleTypeChange}
                        label="Prize Type"
                      >
                        <MenuItem value={"Door"}>Door</MenuItem>
                        <MenuItem value={"Medium"}>Medium</MenuItem>
                        <MenuItem value={"Large"}>Large</MenuItem>
                        <MenuItem value={"AdultCashPrizes"}>Adult Cash Prizes</MenuItem>
                      <MenuItem value={"YouthCashPrizes"}>Youth Cash Prizes</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  {mobileratio ? (
                    <div>
                      <br></br>
                    </div>
                  ) : null}
                </div>
                {mobileratio ? <br></br> : <br></br>}
                <TextField
                  inputRef={updatedescriptionRef}
                  value={viewflag ? viewdescription : null}
                  defaultValue={viewflag ? null : viewdescription}
                  required
                  label="Description"
                  multiline
                  rowsMax={5}
                  variant="outlined"
                  style={{ width: mobileratio ? 262 : 535 }}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                style={{
                  marginRight: mobileratio ? 75 : 15,
                  width: mobileratio ? 267 : 555,
                  backgroundColor: "#171942",
                }}
                onClick={handleViewClose}
              >
                {viewflag ? "close" : "Update"}
              </Button>
            </DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>

      {/* confirmation box */}
      <Dialog
        open={opendeletebox}
        onClose={closeconfirmationbox}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure you want to delete?
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <Button onClick={DeletePrize} color="primary">
            Yes
          </Button>
          <Button onClick={closeconfirmationbox} color="primary">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
